module.exports = "<div class=\"ctx-tabs\">\n    <div class=\"tabs\">\n        <div class=\"tab-button\"\n             ng-repeat=\"tab in ctxTabsCtrl.tabs\"\n             ng-class=\"{active: ctxTabsCtrl.active === tab.name, buttonMode: ctxTabsCtrl.buttonMode}\"\n             ng-click=\"ctxTabsCtrl.switchTab(tab)\">\n            {{ tab.title }}\n        </div>\n    </div>\n    <div class=\"panes\"\n         style=\"overflow: visible; height: auto;\"\n         ng-transclude></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/ctxTabs/ctxTabs.template.html
// module id = 139
// module chunks = 0 1